module.exports = __webpack_public_path__ + "img/android5bg4.3f6fe24f.png";